import { render } from "./ContributeChatMessage.vue?vue&type=template&id=7f21f0c2&scoped=true"
import script from "./ContributeChatMessage.vue?vue&type=script&lang=js"
export * from "./ContributeChatMessage.vue?vue&type=script&lang=js"

import "./ContributeChatMessage.vue?vue&type=style&index=0&id=7f21f0c2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7f21f0c2"

export default script